import { Questions } from '../Questions/Questions'
import React from 'react'
import styles from './Sections.module.scss'
import { Box } from 'components/layout/Box/Box'

export const Sections = ({ sections, isWordDoc = false }) => (
  <Box className={styles.questions} direction="column">
    {sections.map(({ questions, id, title }) => (
      <Box direction="column" key={id} className={styles.question}>
        {isWordDoc ? (
          <p className={styles.sectionTitle}>{title}</p>
        ) : (
          <div className={styles.sectionTitle}>{title}</div>
        )}
        <Questions questions={questions} isWordDoc={isWordDoc} />
      </Box>
    ))}
  </Box>
)
